import axios from 'axios'
import { ref } from 'vue'

export function useCategories({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteCategory = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/categories/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteCategory,
    }
}
